import * as React from 'react'

import { withFormik } from 'formik'

import { EnhancedTextField }       from '../atoms'
import { mapFormikToMuiProps }     from './form-utils'
import { bossSchema, convertBoss } from './schemas'
import asFormStep                  from './wrappers/asFormStep'

const BossChunk = props => {
  const mapper = mapFormikToMuiProps(props)

  return (
    <>
      <EnhancedTextField
        {...mapper('bossName')}
        fullWidth
        margin={'dense'}
        label={'name'}
      />
      <EnhancedTextField
        {...mapper('bossPosition')}
        fullWidth
        margin={'dense'}
        label={'position'}
      />
    </>
  )
}

const formikConfig = {
  mapPropsToValues: ({ values: { boss } }) =>
                      boss
                        ? {
                          bossName:     boss.name,
                          bossPosition: boss.position,
                        }
                        : {
                          bossName:     '',
                          bossPosition: '',
                        }
  ,
  validationSchema: bossSchema,
  handleSubmit:     (values, bag) => {
    bag.props.onSubmit(convertBoss(values))
  },
}

export default withFormik<any, any>(
  formikConfig,
)(
  asFormStep(
    BossChunk,
  ),
)



// WEBPACK FOOTER //
// ./src/components/forms/BossForm.tsx